<template>
  <confirmation-sms
    @cancelAuth="cancelAuth"
    :ciemException="ciemException"
    @confirm="confirm"
    :loading="loading"
    :tel="$auth.tel()"
  />
</template>

<script>
import { alert } from '@/commun/alertMessage'
import Api from '@/utils/api'
import toasted from '@/utils/toasted'

const NAMESPACE = 'doubleAuthentification'
export default {
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.getTel();
  //   });
  // },
  data() {
    return {
      ciemException: alert(),
      loading: false,
      telPortable: null,
    }
  },
  beforeDestroy() {
    this.resetAlert()
  },
  mounted() {
    if (this.$store.state.confirmauthentification.enCours == true) {
      toasted.error('authConfirm.error.alreadyLogued')
      this.$auth.logout()
    }
  },
  methods: {
    confirm(form) {
      // envoyer un code sur le portable de l'utilisateur

      this.loading = true
      new Api(NAMESPACE + '/confirmer-code', 'oauth/')
        .post(form)
        .then((response) => {
          if (response.body.ok === true) {
            this.$store.commit('confirmauthentification/enCours', true)
            this.$store.commit('oauth/canShowListeCorrespondant')
            this.$router.push({
              name: 'Home',
              params: {
                namespaceonly: true,
                sidebar: true,
              },
            })
          } else {
            response.body.ciemException.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              }
            })

            this.$router.push({
              name: 'Login',
            })
            this.$auth.logout()
          }
        })
        .catch((response) => {
          if (
            response.error_description &&
            response.error_description.startsWith('tentative.3')
          ) {
            this.ciemException.error = this.$t(
              'login.' + response.error_description,
            )
            this.resetAlert()
            this.$router.push({
              name: 'Login',
            })
            this.$auth.logout()
            toasted.error('login.' + response.error_description)
          } else if (
            response.error_description &&
            response.error_description.startsWith('tentative')
          ) {
            this.ciemException.warning = this.$t(
              'login.' + response.error_description,
            )
          } else {
            toasted.error(response.error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetAlert() {
      this.ciemException.error = null
      this.ciemException.warning = null
      this.ciemException.success = null
    },
    cancelAuth() {
      this.resetAlert()
      this.$router.push({
        name: 'Login',
      })
      this.$auth.logout()
    },
    // getTel() {
    //   return new Api('/tel-portable', 'api/').get().then(response => {
    //     this.telPortable = response.body;
    //   });
    // },
  },
}
</script>

<style scoped>
.v-input.v-text-field {
  margin-bottom: 10px;
}
</style>
